import { useState, useEffect } from 'react'
import { useRoomViewStore } from 'store/roomView/roomView.store'
import { calculateAverageWaitingTime } from '../helpers'
import { EPatientStatus } from '../RoomView.types'

export const useWaitingRoomLogic = () => {
  const { scheduledSurgeries: rowScheduledSurgeries, waitingRoomPatients } =
    useRoomViewStore()

  const [addButtonAnchorEl, setAddButtonAnchorEl] =
    useState<HTMLElement | null>(null)
  const [averageWaitingTime, setAverageWaitingTime] = useState<string>('N/A')

  const scheduledSurgeries = rowScheduledSurgeries.sort((a, b) => {
    const dateA = new Date(a.procedure.dateTime)
    const dateB = new Date(b.procedure.dateTime)
    return dateA.getTime() - dateB.getTime()
  })

  useEffect(() => {
    const updateAverageWaitingTime = () => {
      const avgTime = calculateAverageWaitingTime(
        scheduledSurgeries.filter(
          (surgery) =>
            surgery.patientStatusHistory[0]?.status ===
            EPatientStatus.CHECKED_IN
        )
      )
      setAverageWaitingTime(avgTime)
    }

    updateAverageWaitingTime()

    const interval = setInterval(() => {
      updateAverageWaitingTime()
    }, 60000)

    return () => clearInterval(interval)
  }, [scheduledSurgeries])

  const handleAddButtonClick = (event: React.MouseEvent<HTMLElement>) => {
    setAddButtonAnchorEl(event.currentTarget)
  }

  const handleAddButtonClose = () => {
    setAddButtonAnchorEl(null)
  }

  const getAverageWaitingTime = () => {
    return averageWaitingTime
  }

  return {
    addButtonAnchorEl,
    scheduledSurgeries,
    waitingRoomPatients,
    handleAddButtonClose,
    handleAddButtonClick,
    getAverageWaitingTime,
  }
}
